import { useEffect, useState } from 'react';
import HeroParticles from './HeroParticles';

export default function Hero() {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setLoaded(true), 100);
    return () => clearTimeout(t);
  }, []);

  return (
    <section className="relative w-full min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e156ddf6eadc6976a4d360aa8bd479a4.jpg"
          alt="Global Trade"
          className="w-full h-full object-cover object-center"
        />
        {/* Deep overlay */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/60 to-black/85" />
        <div className="absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-black/50" />
      </div>

      {/* Gold particle canvas layer */}
      <HeroParticles />

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 lg:px-10 text-center">

        {/* Thin gold line above title */}
        <div
          className={`flex justify-center mb-6 transition-all duration-700 delay-200 ${
            loaded ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-px bg-gradient-to-r from-transparent to-gold/60" />
            <span className="text-[9px] text-gold/70 tracking-[0.35em] uppercase font-medium">Est. Hong Kong</span>
            <div className="w-10 h-px bg-gradient-to-l from-transparent to-gold/60" />
          </div>
        </div>

        {/* Main Title */}
        <div
          className={`transition-all duration-800 delay-400 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
          }`}
        >
          <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl xl:text-8xl font-light text-white leading-tight mb-4">
            ABUMI<br />
            <span className="gold-shimmer font-medium">Trading Company</span>
          </h1>
          <p className="font-heading text-xl md:text-2xl text-[#C0C0C0] font-light tracking-widest uppercase mt-3 mb-8">
            Global Export &amp; Sourcing Solutions
          </p>
        </div>

        {/* Divider */}
        <div
          className={`flex justify-center mb-8 transition-all duration-700 delay-600 ${
            loaded ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <div className="w-16 h-px bg-gradient-to-r from-transparent via-gold to-transparent" />
        </div>

        {/* Description */}
        <div
          className={`transition-all duration-700 delay-700 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <p className="text-sm md:text-base text-[#A0A0A0] font-light leading-relaxed max-w-2xl mx-auto mb-12 tracking-wide">
            Connecting China to Africa and the Middle East through vehicles, machinery, and full-scale project supply.
          </p>
        </div>

        {/* CTA Buttons */}
        <div
          className={`flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-700 delay-900 ${
            loaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'
          }`}
        >
          <a
            href="#services"
            className="px-10 py-4 bg-gold text-charcoal text-xs font-semibold tracking-[0.18em] uppercase hover:bg-gold-light transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Explore Our Services
          </a>
          <a
            href="#contact"
            className="px-10 py-4 border border-gold/60 text-gold text-xs font-semibold tracking-[0.18em] uppercase hover:border-gold hover:bg-gold/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Get In Touch
          </a>
        </div>

        {/* Scroll Indicator */}
        <div
          className={`absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 transition-all duration-700 delay-1000 ${
            loaded ? 'opacity-100' : 'opacity-0'
          }`}
        >
          <span className="text-[10px] text-[#666] tracking-[0.25em] uppercase">Scroll</span>
          <div className="w-px h-12 bg-gradient-to-b from-gold/60 to-transparent animate-pulse" />
        </div>
      </div>
    </section>
  );
}
